<template lang="html">
  <div>
    <episode-detail
      mode="update"
      :show-slug="showSlug"
      :episode-id="episodeId"
    />
  </div>
</template>

<script>
  import EpisodeDetail from './episode-detail.vue'
  export default {
    components: {
      EpisodeDetail
    },
    data () {
      return {
        showSlug: this.$route.params.slug,
        episodeId: parseInt(this.$route.params.id)
      }
    },
    computed: {},
    methods: {},
    mounted () {
      // let that = this
      // that.$api.episode.detail(that.$route.params.id).then(res => {
      //   window.console.log("获取到Episode Detail")
      //   // window.console.log(res)
      //   that.episode = res.data
      //   window.console.log(that.episode)
      // })
    }
  }
</script>

<style lang="css" scoped>
</style>
